import { useEffect, useState, useRef } from 'react';
import styles from './Achievements.module.css';
import { TbArrowBigRightFilled } from 'react-icons/tb';
import data from '../../../data/achievements.json'; // pad aanpassen indien nodig

const groupByYear = (data) => {
  return data
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .reduce((acc, item) => {
      const year = new Date(item.date).getFullYear();
      acc[year] = acc[year] || [];
      acc[year].push(item);
      return acc;
    }, {});
};

export function Achievements() {
  const grouped = groupByYear(data);
  const [openYears, setOpenYears] = useState({});
  const refs = useRef({});

  const toggleYear = (year) => {
    setOpenYears((prev) => ({ ...prev, [year]: !prev[year] }));
  };

  useEffect(() => {
    Object.entries(grouped).forEach(([year]) => {
      const el = refs.current[year];
      if (el) {
        el.style.height = openYears[year] ? `${el.scrollHeight}px` : '0px';
      }
    });
  }, [openYears]);

  return (
    <div className={styles.timelineContainer}>
      {Object.entries(grouped)
        .sort((a, b) => b[0] - a[0])
        .map(([year, items]) => (
          <div key={year} className={styles.yearBlock}>
            <div className={styles.yearHeader} onClick={() => toggleYear(year)}>
              <h2>{year}</h2>
              <div
                className={styles.yearArrow}
                style={{
                  transform: openYears[year] ? 'rotate(90deg)' : 'rotate(0deg)',
                  transition: 'transform 0.3s ease'
                }}
              >
                <TbArrowBigRightFilled />
              </div>
            </div>
            <div
              ref={(el) => (refs.current[year] = el)}
              className={styles.entries}
              style={{ height: openYears[year] ? `${refs.current[year]?.scrollHeight}px` : '0px' }}
            >
              {items.map((item, idx) => (
                <div key={idx} className={styles.achievementEntry}>
                  <div
                    className={styles.achievementImage}
                    style={{ backgroundImage: `url(${item.image})` }}
                  />
                  <div className={styles.achievementText}>
                    <h3>{item.title}</h3>
                    <p><strong>{item.location}</strong></p>
                    <p>
                      <em>
                        {new Date(item.date).toLocaleDateString('nl-BE', {
                          day: 'numeric',
                          month: 'long',
                          year: 'numeric',
                        })}
                      </em>
                    </p>
                    <p>{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
    </div>
  );
}